import App from "./App";

document.addEventListener("DOMContentLoaded", () => {
  const root = document.getElementById("root");
  App(root);
});
